export default {"src":"/_next/static/media/chart-line-solid.80749ce8.svg","height":24,"width":24};